export default {
  cashflowOverview: '/cashflow/overview',
  fabrickSuccess: '/cashflow/fabrick/success',
  fabrickError: '/cashflow/fabrick/error',
  tagManagement: '/cashflow/tag-management',
  cardOnboardingResult: '/card-onboarding/result'
}